var shared = require('../../modules/shared');
var _vars = require('../../modules/vars')._vars;
var ctaHTML = require('../../ui/templates/compare-treatments.template');

var DESKTOP_COMPARE_PROMPT_TEMPLATE = 'Compare the primary treatment options for [condition name], including the most clinically relevant criteria for evaluation. Put results in a table.';
var MOBILE_COMPARE_PROMPT_TEMPLATE = 'Compare the primary treatment options for [condition name], including the most clinically relevant criteria for evaluation. Put results in a table with maximum 3 columns.';

function isMobileViewport() {
    if (typeof window.breakpoint !== 'undefined') {
        return Number(window.breakpoint) === 1;
    }
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
}

function resolveConditionName() {
    var titleElementParent = document.querySelector('#drugdb');
    var h1 = titleElementParent.querySelector('h1');

    if (h1 && h1.textContent) {
        var condition = h1.textContent.trim();
        condition = condition.replace(/Treatment & Management.*$/i, '').trim();
        return condition;
    }

    return '';
}

function buildCompareTreatmentsPrompt() {
    var conditionName = resolveConditionName();
    var template = isMobileViewport() ? MOBILE_COMPARE_PROMPT_TEMPLATE : DESKTOP_COMPARE_PROMPT_TEMPLATE;
    return template.replace('[condition name]', conditionName);
}

function handleCompareTreatmentsClick(event) {
    event.preventDefault();
    wmdTrack('ai-search_cmpr-trtmnts');
    aiSchPageview(0);
    var prompt = buildCompareTreatmentsPrompt();

    // Suppress the Key Points card for this response only (PROFCORE Compare Treatments UX)
    _vars.suppressKeyPointsOnce = true;
    // Show Layer
	if(!document.body.classList.contains('show-ai-search-modal')) {
		document.getElementById('ai-search-fab').classList.remove('active');
		document.body.classList.add('show-ai-search-modal');
    }
    shared.handleSearch(prompt);
}

function bindCompareTreatmentsCTA(ctaContainer) {
    var ctaRoot = ctaContainer.querySelector('.compare-treatments-cta');
    if (!ctaRoot || ctaRoot.getAttribute('data-compare-bound') === 'true') {
        return;
    }

    ctaRoot.addEventListener('click', handleCompareTreatmentsClick);
}

function initCompareTreatment() {
    var ctaContainer = document.getElementById('ai-compare-treatment-wrapper');
    if (!ctaContainer) {
        return;
    }

    if (!ctaContainer.querySelector('.compare-treatments-cta')) {
        ctaContainer.insertAdjacentHTML('beforeend', ctaHTML.compareTreatmentsTemplate());
        bindCompareTreatmentsCTA(ctaContainer);
    }

}

module.exports = {
    initCompareTreatment: initCompareTreatment
};